import Header from "./Compartido/Header";
import DatosPrivados from "./MisDatos/DatosPrivados";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";

const MisDatos = (props) => {
    return (
        <>
            <Header
                config={props.websgrupo}
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                idiomas={props.idiomas}
                destinos={props.destinos}
                experiencias={props.experiencias}
            />

            <div className="rewards page-rewards">
                <DatosPrivados
                    lang={props.lang}
                    cliente={props.cliente}
                    idiomas={props.idiomas}
                    paises={props.paises}
                    tiposdocs={props.tiposdocs}
                    reservas={props.reservas}
                    faqs={props.faqs}
                    ruta={props.ruta}
                    config={props.websgrupo}
                />
                <app-footer>
                    <BrandsSection
                        lang={props.lang}
                        marcas={props.marcas}
                        ruta={props.ruta}
                    />
                    <Footer
                        lang={props.lang}
                        config={props.websgrupo}
                    />
                </app-footer>
            </div>

        </>
    );
}

export default MisDatos;
